import { NEXT_PUBLIC_WEAR2_WEB_URL } from '~/lib/env'

const baseUrl = new URL(NEXT_PUBLIC_WEAR2_WEB_URL)
export const useBaseUrl = (): URL => baseUrl
